import { Pipe, PipeTransform } from '@angular/core';
import { mcpKeysConversionMap } from 'src/app/models/constants/mcpKeysNaming.constants';

@Pipe({
  name: 'beautifyMcpNaming',
  standalone: true,
})
export class BeautifyMcpNamingPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) {
      return '';
    }

    if (value === mcpKeysConversionMap['client'].key) {
      return mcpKeysConversionMap['client'].value;
    }

    if (value === mcpKeysConversionMap['host'].key) {
      return mcpKeysConversionMap['host'].value;
    }

    if (value === mcpKeysConversionMap['connection'].key) {
      return mcpKeysConversionMap['connection'].value;
    }

    return value;
  }
}
